
import axios from 'axios';
import { awsUrl } from '../../axiosInstance';
import * as actionType from '../store/action'
import { setPreload } from '../server/CartsOpen';

export const getAllCategory = () => {
    return dispatch => {
        axios.get(`${awsUrl}/v1/categories`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`
            },
        })
            .then(x => {
                if (!Array.isArray(x.data)) {
                    x.data = []
                }
                dispatch({ type: actionType.SET_ALL_CATEGORY, payload: x.data })
            })
    }
}

export const CategoryAdd = (data) => {
    return dispatch => {
        dispatch(setPreload(true));
        axios.post(`${awsUrl}/v1/categories`, data, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        }).then(x => dispatch({ type: actionType.ADD_CATEGORY, payload: x.data }))
            .finally(() => dispatch(setPreload(false)));

    }
}

export const CategoryDelete = (data) => {
    return dispatch => {
        dispatch(setPreload(true));
        axios.delete(`${awsUrl}/v1/categories/${data}`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        })
            .then(x => dispatch({ type: actionType.DELETE_CATEGORY, payload: data }))
            .finally(() => dispatch(setPreload(false)));

    }
}



export const CategoryUpdate = (data) => {
    return dispatch => {
        // dispatch(setPreload(true));
        axios.put(`${awsUrl}/v1/categories`, {
            id: data.Mkt,
            key: data.Title,
            value: data.value
        }, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        }).then(x => {
            dispatch({
                type: actionType.EDIT_CATEGORY, payload: {
                    id: data.Mkt,
                    paramName: data.Title,
                    value: data.value
                }
            })
        })
            .finally(() => dispatch(setPreload(false)));
    }
}

export const CategorySetImg = (data) => dispatch => dispatch({ type: actionType.EDIT_CATEGORY, payload: data })